import Handsontable from 'handsontable';
import { getAllCellsBetween } from '../tableCellSelectionUtils';

/**
 * This function is used to set the *temporary* cell color (for now, see to-do below) when the user is
 * using the custom color picker because it can update many times very quickly, for that reason we
 * are updating the hotTable instance directly to render the new colour, but not saving to redux
 */
export const setHotTableCellBackgroundColor = (
    hotInstance: Handsontable,
    cellSelections = hotInstance.getSelected(),
    backgroundColor: string | null,
) => {
    if (!cellSelections) return;

    getAllCellsBetween(cellSelections).forEach((cell) => {
        const { row, col } = cell;
        const currentCellData = hotInstance.getCellMeta(row, col)?.cellData || {};
        hotInstance.setCellMetaObject(row, col, {
            cellData: { ...currentCellData, background: backgroundColor },
        });
    });

    hotInstance.render();
};
